<form [formGroup]="form">
	<lvr-section-form>
		<!-- Institution select Field (Institution)-->
		@let institutionCtrl = form.get('institution');
		<lvr-field
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
			[label]="labelAppendAsterisk('client.career.institution' | transloco)"
		>
			<ng-template #institutionOption let-institution>
				<div class="institution-option">
					<span class="institution-name">
						{{ institution.item.name }}
					</span>

					<span class="institution-sub">
						@if (institution.item.address?.location || institution.item.address?.postalCode) {
							{{ institution.item.address?.street }}
							{{ institution.item.address?.housenumber }}
							-
							{{ institution.item.address?.postalCode }}
							{{ institution.item.address?.location }}
						} @else {
							{{ 'global_search.unknown' | transloco }}
						}
					</span>
				</div>
			</ng-template>
			<lvr-searchable-select
				formControlName="institution"
				[options]="institutionSearchResults()"
				[optionValue]="institutionValue"
				[optionLabel]="institutionLabel"
				[optionTemplate]="institutionOption"
				[placeholder]="'institution.create.search_placeholder' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'institution.create.no_suggestion' | transloco"
				(searchChange)="searchInstitutions($event)"
				(scrolledToEnd)="loadNextInstitutionResults()"
				[required]="isSocialSecurityStatusActivityJ()"
				[hasError]="hasError(institutionCtrl, 'required')"
				[errorMessage]="'client.career.error.required' | transloco"
			/>
		</lvr-field>

		<!-- linked branch field (Verknüpfte Zweigstelle) -->
		@let branchCtrl = form.get('branchId');
		<lvr-field
			[label]="labelAppendAsterisk('client.career.branch' | transloco)"
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
		>
			<ng-template #branchOption let-branch>
				<div class="branch-option">
					<div class="branch-name">
						{{ branch.name }}

						@if (branch.isMainInstitution) {
							<span class="branch-sub">{{ 'client.career.main_branch' | transloco }}</span>
						}
					</div>

					<div class="branch-sub">
						{{ branch.address?.postalCodeAndCity }}
						-
						{{ branch.address.postalCodeAndCity }}
					</div>
				</div>
			</ng-template>

			<lvr-searchable-select
				formControlName="branchId"
				[options]="branches()"
				[optionLabel]="branchLabel"
				[optionTemplate]="branchOption"
				[placeholder]="'base.field.select_please' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'institution.create.no_suggestion' | transloco"
				[ariaLabel]="'client.career.branch' | transloco"
				[required]="isSocialSecurityStatusActivityJ()"
				[hasError]="hasError(branchCtrl, 'required')"
				[errorMessage]="'client.career.error.required' | transloco"
				[hintText]="'client.career.branchHint' | transloco"
			/>
		</lvr-field>

		<!-- institution person field (Ansprechpartner der Institution) -->
		<lvr-field [label]="'client.career.person' | transloco" lvrPadding [padHorizontal]="16" [padVertical]="0">
			<lvr-searchable-select
				formControlName="personId"
				[options]="persons()"
				[optionLabel]="personLabel"
				[placeholder]="'base.field.select_please' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'institution.create.no_suggestion' | transloco"
				[ariaLabel]="'client.career.person' | transloco"
				[hintText]="'client.career.personHint' | transloco"
			></lvr-searchable-select>
		</lvr-field>

		<!-- Institution City District -->
		@let cityDistrictCtrl = form.get('cityDistrictId');
		<lvr-field
			[label]="labelAppendAsterisk('base.field.workplace_district' | transloco)"
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
		>
			<lvr-searchable-select
				formControlName="cityDistrictId"
				[options]="cityDistricts()"
				[placeholder]="'base.field.select_please' | transloco"
				[searchPlaceholder]="'base.field.search_placeholder' | transloco"
				[noResultsText]="'base.field.no_results' | transloco"
				[ariaLabel]="'base.field.residence_district' | transloco"
				[required]="isSocialSecurityStatusActivityJ()"
				[hasError]="hasError(cityDistrictCtrl, 'required')"
				[errorMessage]="'client.career.error.required' | transloco"
			></lvr-searchable-select>
		</lvr-field>

		<!-- job title Field (Tätigkeit) -->
		@let jobTitleCtrl = form.get('jobTitle');
		<lvr-field
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
			[label]="labelAppendAsterisk('client.career.jobTitle' | transloco)"
		>
			<mat-form-field lvrInput [lvrError]="hasError(jobTitleCtrl, 'maxLength', 'required')">
				<input
					matInput
					formControlName="jobTitle"
					placeholder="Mittleres Management"
					[aria-required]="isSocialSecurityStatusActivityJ()"
					[maxlength]="env.formConfiguration.career.jobTitleLength"
					[errorStateMatcher]="matcher"
				/>
				@if (hasError(jobTitleCtrl, 'required')) {
					<mat-error>{{ 'client.career.error.required' | transloco }}</mat-error>
				}
				@if (hasError(jobTitleCtrl, 'maxLength')) {
					<mat-error>{{
						'client.career.error.maxLength' | transloco: { max: env.formConfiguration.career.jobTitleLength }
					}}</mat-error>
				}
				<mat-hint>{{
					'client.career.hint.maxLength'
						| transloco: { actual: jobTitleCtrl?.value?.length || 0, max: env.formConfiguration.career.jobTitleLength }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>

		<!-- Type and Scope of the Workplace Field (Art und Umfang der Beschäftigung) -->
		@let typeAndScopeCtrl = form.get('typeAndScopeOfTheWorkplace');
		<lvr-field
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
			[label]="labelAppendAsterisk('client.career.typeAndScopeOfTheWorkplace' | transloco)"
		>
			<mat-form-field lvrInput [lvrError]="hasError(typeAndScopeCtrl, 'required', 'maxLength')">
				<textarea
					matInput
					formControlName="typeAndScopeOfTheWorkplace"
					placeholder="Vollzeit"
					[aria-required]="isSocialSecurityStatusActivityJ()"
					[errorStateMatcher]="matcher"
					[maxlength]="env.formConfiguration.career.typeAndScopeOfTheWorkplaceLength"
				></textarea>
				@if (hasError(typeAndScopeCtrl, 'required')) {
					<mat-error>{{ 'client.career.error.required' | transloco }}</mat-error>
				}
				@if (hasError(typeAndScopeCtrl, 'maxLength')) {
					<mat-error>{{
						'client.career.error.maxLength'
							| transloco: { max: env.formConfiguration.career.typeAndScopeOfTheWorkplaceLength }
					}}</mat-error>
				}
				<mat-hint>{{
					'client.career.hint.maxLength'
						| transloco
							: {
									actual: typeAndScopeCtrl?.value?.length || 0,
									max: env.formConfiguration.career.typeAndScopeOfTheWorkplaceLength,
							  }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>

		<!-- Remark Field (Beschreibung) -->
		@let remarkCtrl = form.get('remark');
		<lvr-field lvrPadding [padHorizontal]="16" [padVertical]="0" [label]="'base.field.remark' | transloco">
			<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'maxLength')">
				<textarea
					matInput
					formControlName="remark"
					placeholder="Bemerkung"
					[maxlength]="env.formConfiguration.career.remarkLength"
					[errorStateMatcher]="matcher"
				></textarea>
				@if (hasError(remarkCtrl, 'maxLength')) {
					<mat-error>{{
						'client.career.error.maxLength' | transloco: { max: env.formConfiguration.career.remarkLength }
					}}</mat-error>
				}
				<mat-hint>{{
					'client.career.socialSecurityStatusRemarkHint'
						| transloco: { actual: remarkCtrl?.value?.length || 0, max: env.formConfiguration.career.remarkLength }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>

		<!-- Institution Informed Field (Institution informiert) -->
		<lvr-field
			lvrPadding
			[padHorizontal]="16"
			[padVertical]="0"
			[label]="'client.career.institutionInformed' | transloco"
		>
			<br />
			<mat-checkbox
				[attr.aria-label]="'client.career.institutionInformed' | transloco"
				formControlName="institutionInformed"
				>{{ 'client.career.informed' | transloco }}</mat-checkbox
			>
		</lvr-field>
	</lvr-section-form>
</form>
